import React from 'react';
import cn from 'classnames';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import PointsIcon from '@wix/da-ds/pkg/Icons/Points';
import UserLink from '../../../User/Link/UserLink';
import UserAvatar from '../../../User/Avatar/UserAvatar';
import { formatDollars } from '../../../utils/formatting';
import { getDeviationPrice } from '../../helpers';
import s from './Details.scss';
const USER_AVATAR_SIZE = 24;
const Details = ({ deviation, className })=>{
    const { dollarsPrice, pointsPrice } = getDeviationPrice(deviation);
    return /*#__PURE__*/ React.createElement("div", {
        className: cn(s['root'], className)
    }, /*#__PURE__*/ React.createElement("div", {
        className: s['avatar']
    }, /*#__PURE__*/ React.createElement(UserAvatar, {
        user: deviation.author,
        size: USER_AVATAR_SIZE
    })), /*#__PURE__*/ React.createElement("div", {
        className: s['title']
    }, deviation.title), /*#__PURE__*/ React.createElement("div", {
        className: s['price-dollars']
    }, dollarsPrice && formatDollars(dollarsPrice)), /*#__PURE__*/ React.createElement("div", {
        className: s['username']
    }, /*#__PURE__*/ React.createElement(UserLink, {
        user: deviation.author
    })), /*#__PURE__*/ React.createElement("div", {
        className: s['price-points']
    }, pointsPrice && /*#__PURE__*/ React.createElement(PointsIcon, {
        size: IconSize.TINY,
        disableDefaultColors: true
    }), pointsPrice));
};
Details.displayName = 'Details';
export default Details;
